import _ from 'lodash';

import Image from 'models/image';
import PlaybackRules from 'models/playbackrules';

/**
 * Model of a linear channel.
 */
class LinearChannel {

    /**
     * Constructor of the model.
     *
     * @param {Object} item - Data of the linear.
     */
    constructor (item = {}) {
        this.apiSpecifics = {
            externalIds: item.externalIds || '',
            objectType: item.objectType || ''
        };
        this.playbackRules = new PlaybackRules(item || {});
        this.entryId = item.entryId || '';
        this.id = item.id || '';
        this.type = item.type || '';
        this.name = item.name || '';
        this.description = item.description || '';
        this.images = _.map(item.images || [], data => {
            return new Image(data);
        });
        this.mediaFiles = item.mediaFiles || [];
        this.metas = item.metas || {};
        this.tags = item.tags || {};
        this.startDate = item.startDate || '';
        this.endDate = item.endDate || '';

        return this;
    }
}

export default LinearChannel;


// WEBPACK FOOTER //
// ./src/js/models/asset/linear.js